import LumenLogo from './lumen.png';
import dataTestids from '../../constants/test-ids';

export const LumenDashboardLogo = () => {
  return (
    <img
      width='187'
      height='50'
      src={LumenLogo}
      alt='user-plan-partner-logo'
      data-testid={dataTestids.DASHBOARD.NAVBAR.LOGO}
    ></img>
  );
};
